import { DisparityQuadtree, hasOwnProperty, isNull, PerspectiveImageQuadtree, } from "../../infra3d";
import { IMAGEDISPLAYMODE, MEASUREMODE } from "../internal";
import { StereoMeasureSequence } from "../measure/internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { GeoFrameCollection } from "./geoframecollection";
import { AuthMode } from "../viewer/AuthMode";
// TODO: Naming currently along the lines of stream.
export class StereoGeoFrameCollection extends GeoFrameCollection {
    constructor(scene, currentgeoframe, geoframearray) {
        super(scene, currentgeoframe, geoframearray);
        this.setOnImageChanged = function (f) {
            this.onimagechanged = f;
        };
        this.imagequadtree = null;
        this.rightimagequadtree = null;
        this.disparityquadtree = null;
        this.activeimage = "unknow";
        this._rightindicatorcanvas = null;
        this.onimagechanged = null;
        this._keyEnter = -1;
    }
    // TODO: Naming.
    load(frame = null) {
        if (this.onbuffering)
            this.onbuffering(true);
        let framenumber = frame ? this.frameIndex(frame) : 0;
        this.activeimage = "left";
        //
        // right imagequadtree
        //
        const urls = [];
        for (const geoframe of this.geoframearray) {
            urls.push(geoframe.dataPath);
        }
        const frameZeroCoord = [
            this.currentgeoframe.easting,
            this.currentgeoframe.northing,
            this.currentgeoframe.height,
        ];
        const centroid = frameZeroCoord;
        const frameZeroOri = [this.currentgeoframe.omega, this.currentgeoframe.phi, this.currentgeoframe.kappa];
        const imagemeta = this.measureinfo.imagemeta;
        this.rightimagequadtree = new PerspectiveImageQuadtree(urls, imagemeta.tilesize, imagemeta.width, imagemeta.height, imagemeta.minzoom, imagemeta.maxzoom, 15, frameZeroCoord, frameZeroOri, imagemeta.pixsize, imagemeta.focallength, 1200, true // NOTE: Says this is a stereo right.
        );
        this.infrascene.add(this.rightimagequadtree);
        this.rightimagequadtree.setActive(false);
        this.rightimagequadtree.setImageIndex(framenumber);
        if (this.currentgeoframe != null) {
            framenumber = this.currentgeoframe.getFramenumber();
        }
        const numEntries = this.geoframearray.length;
        const mlt = 1.0 / numEntries;
        let eastingCenter = 0;
        let northingCenter = 0;
        let heightCenter = 0;
        for (let i = 0; i < numEntries; i++) {
            eastingCenter = eastingCenter + mlt * this.geoframearray[i].easting;
            northingCenter = northingCenter + mlt * this.geoframearray[i].northing;
            heightCenter = heightCenter + mlt * this.geoframearray[i].height;
        }
        this.centroid = [eastingCenter, northingCenter, heightCenter];
        this.infrascene.engine.setCentroid(centroid);
        //
        // left imagequadtree
        //
        this.imagequadtree = new PerspectiveImageQuadtree(urls, imagemeta.tilesize, imagemeta.width, imagemeta.height, imagemeta.minzoom, imagemeta.maxzoom, 15, frameZeroCoord, frameZeroOri, imagemeta.pixsize * 0.000001, imagemeta.focallength * 0.001);
        this.scene.infrascene.panoramaMode = false;
        //
        // other stuff, hock up effent of quadtrees
        //
        // FIXME: Move to method.
        this.cachnotreadycbf = () => {
            this.cacheready = false;
            if (this.onbuffering) {
                this.onbuffering(true);
            }
        };
        this.imagequadtree.cacheNotReadyEvent = () => {
            this.cachnotreadycbf();
        };
        // FIXME: Move to method. Or just only have cacheready and on buffering. There is actually no need for these two prototeced methods.
        this.cachereadycbf = () => {
            this.cacheready = true;
            if (this.onbuffering) {
                this.onbuffering(false);
            }
        };
        this.imagequadtree.cacheReadyEvent = () => {
            this.cachereadycbf();
        };
        this.imagequadtree.visibleTilesNotReady = () => {
            this.alltilesready = false;
            if (this.onTileLoading) {
                this.onTileLoading(true);
            }
        };
        this.imagequadtree.visibleTilesReady = () => {
            this.alltilesready = true;
            if (this.onTileLoading) {
                this.onTileLoading(false);
            }
        };
        this.stoppedcbf = () => {
            if (this.disparityquadtree != null) {
                this.disparityquadtree.setDataIndex(this.getCurrentFramenumber());
            }
        };
        this.imagequadtree.stoppedEvent = () => {
            this.stoppedcbf();
        };
        this.infrascene.add(this.imagequadtree);
        this.imagequadtree.setActive(true);
        this.imagequadtree.setImageIndex(this.getCurrentFramenumber());
        //
        // load disparity quadtree
        //
        const depthmapmeta = this.measureinfo.depthmapmeta;
        if (hasOwnProperty(this.measureinfo.depthmapmeta, "structure")) {
            if (this.measureinfo.depthmapmeta.structure !== "none" && this.scene.authmode == AuthMode.edit) {
                this.disparityquadtree = new DisparityQuadtree(urls, depthmapmeta.tilesize, depthmapmeta.width, depthmapmeta.height, depthmapmeta.minzoom, depthmapmeta.maxzoom);
                this.disparityquadtree.currentImageIndex = framenumber;
                this.infrascene.add(this.disparityquadtree);
            }
        }
        //
        // set camera parameters
        //
        this.infrascene.sceneCamera.setPosition([
            this.geoframearray[framenumber].easting,
            this.geoframearray[framenumber].northing,
            this.geoframearray[framenumber].height,
        ]);
        this.infrascene.sceneCamera.setOrientation([
            this.geoframearray[framenumber].omega,
            this.geoframearray[framenumber].phi,
            this.geoframearray[framenumber].kappa,
        ]);
        this.infrascene.sceneCamera.setCameraIntrinsics({
            IMAGE_WIDTH: imagemeta.width,
            IMAGE_HEIGHT: imagemeta.height,
            PIXEL_SIZE: imagemeta.pixsize * 0.000001,
            NEAR: imagemeta.focallength * 0.001,
            MIN_ZOOM: imagemeta.minzoom,
            MAX_ZOOM: imagemeta.maxzoom,
        });
        this.imagequadtree.framechangedcbf = () => {
            this._imageChanged();
        };
        this.hasloaded = true;
        // FIXME: Add reverse mode? Why.
        this.displaymode = IMAGEDISPLAYMODE.FRAMESTEPPING;
        this.searchToFramenumber(framenumber);
        this.fitToCanvas();
        this._keyEnter = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ENTER, this._onKeyEnter, this);
    }
    unload() {
        if (this.scene.getMeasureHandler().activeMeasureSequence instanceof StereoMeasureSequence) {
            this.scene.getMeasureHandler().abortMeasureSequence();
        }
        this.hideImageSideIndicator();
        this.infrascene.remove(this.rightimagequadtree);
        // FIXME / REVIEW: Does rightimagequadtree not need more cleaning up?
        this.infrascene.remove(this.imagequadtree);
        this.imagequadtree.setActive(false);
        this.imagequadtree.destroy();
        this.imagequadtree = null;
        try {
            this.infrascene.remove(this.disparityquadtree);
            this.disparityquadtree.destroy();
            this.disparityquadtree = null;
        }
        catch (e) {
            console.log("ERROR stream unload");
        }
        if (this.lookatfc != null) {
            this.lookatfc.destroy();
            this.lookatfc = null;
        }
        this.hasloaded = false;
    }
    // FIXME: Most likely private.
    _onKeyEnter() {
        if (this.scene.getMeasureHandler().measureSequenceInProgress ||
            this.scene.getMeasureMode() != MEASUREMODE.LEFTRIGHT) {
            return;
        }
        if (this.activeimage == "right") {
            this.showLeftImage();
        }
        else {
            this.showRightImage();
        }
    }
    showRightImage() {
        if (this.hasloaded && this.activeimage == "left") {
            this.updateImageSideIndicator();
            const cf = this.imagequadtree.currentImageIndex;
            this.imagequadtree.tileContainer.visible = false;
            this.rightimagequadtree.tileContainer.visible = true;
            this.rightimagequadtree.setImageIndex(cf);
            this.rightimagequadtree.setActive(true);
            this.activeimage = "right";
            this.updateImageSideIndicator();
            const rpc = this.currentgeoframe.getRightProjectionCenter();
            this.infrascene.traversalState.cameras["sceneCamera"].behaviors[0].setPosition([rpc[0], rpc[1], rpc[2]]);
            this.infrascene.render();
            if (this.onimagechanged !== null) {
                this.onimagechanged(this.activeimage);
            }
        }
    }
    showLeftImage() {
        if (this.hasloaded && this.activeimage == "right") {
            this.updateImageSideIndicator();
            this.imagequadtree.tileContainer.visible = true;
            this.rightimagequadtree.tileContainer.visible = false;
            this.rightimagequadtree.setActive(false);
            this.activeimage = "left";
            this.updateImageSideIndicator();
            this.infrascene.traversalState.cameras["sceneCamera"].behaviors[0].setPosition([
                this.currentgeoframe.easting,
                this.currentgeoframe.northing,
                this.currentgeoframe.height,
            ]);
            this.infrascene.render();
            if (this.onimagechanged !== null) {
                this.onimagechanged(this.activeimage);
            }
        }
    }
    hide() {
        this.rightimagequadtree.hide = true;
        super.hide();
    }
    show() {
        this.rightimagequadtree.hide = false;
        super.show();
    }
    searchToFramenumber(framenumber) {
        if (!this.cacheready) {
            return;
        }
        this.showLeftImage();
        return super.searchToFramenumber(framenumber);
    }
    showImageSideIndicator() {
        // right image indicator definition
        this._rightindicatorcanvas = document.createElement("canvas");
        this._rightindicatorcanvas.style.width = "50px";
        this._rightindicatorcanvas.style.height = "50px";
        this._rightindicatorcanvas.width = 50;
        this._rightindicatorcanvas.height = 50;
        this._rightindicatorcanvas.style.position = "absolute";
        this._rightindicatorcanvas.style.left = "0px";
        this._rightindicatorcanvas.style.bottom = "35px";
        this.infrascene.engine.getCanvas().parentElement.appendChild(this._rightindicatorcanvas);
        this.updateImageSideIndicator();
    }
    updateImageSideIndicator() {
        if (!isNull(this._rightindicatorcanvas)) {
            const label = this.activeimage == "left" ? "L" : "R";
            const ctx = this._rightindicatorcanvas.getContext("2d");
            ctx.clearRect(0, 0, this._rightindicatorcanvas.width, this._rightindicatorcanvas.width);
            ctx.shadowColor = "black";
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.shadowBlur = 2;
            ctx.font = "40px Verdana";
            ctx.fillStyle = "white";
            ctx.fillText(label, 5, 40);
            ctx.strokeStyle = "black";
            ctx.strokeText(label, 5, 40);
        }
    }
    hideImageSideIndicator() {
        if (!isNull(this._rightindicatorcanvas)) {
            this.infrascene.engine.getCanvas().parentElement.removeChild(this._rightindicatorcanvas);
            this._rightindicatorcanvas = null;
        }
    }
    getDisplayMode() {
        // REVIEW: Is this even correct would it not be better to check if left or right and then give
        //         the displayMode of the specific quadtree.
        return this.imagequadtree.displayMode;
    }
}
//# sourceMappingURL=stereogeoframecollection.js.map